import { useState, useRef, useEffect } from "react";
import { TextField } from "@material-ui/core";
import SingleDropDown from "../SingleDropDown";
import { KeyboardDatePicker } from "@material-ui/pickers";
import GenderAutocomplete from "./GenderAutocomplete";
import TooltipIcon from "../TooltipIcon/TooltipIcon";

const _spacing = "10px";

const UqForm = props => {
  const inputLabel = useRef(null);
  const [labelWidth, setLabelWidth] = useState(0);

  useEffect(() => {
    if (inputLabel.current) {
      setLabelWidth(inputLabel.current.offsetWidth);
    }
  }, []);

  const handleChange = e => {
    const name = e.target.name;
    const value = e.target.value;
    props.setQueryState(prevState => {
      return { ...prevState, [name]: value };
    });
  };

  const handleDateChange = (date, str) => {
    props.setQueryState(prevState => {
      return { ...prevState, dob: str };
    });
  };

  return (
    <div
      data-testid="uq-form"
      id="bottom-half"
      style={{ display: "flex", flexDirection: "column", rowGap: "10px" }}
    >
      {props.children}
      <div
        id="group1"
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          border: "1px solid black",
          justifyContent: "space-between",
          padding: _spacing,
        }}
      >
        <TextField
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          margin="dense"
          id="name-id"
          label="Name"
          helperText="Last Name, First Name Middle Initial"
          value={props?.queryState?.name || ""}
          onChange={handleChange}
          name="name"
          style={{ width: "45%" }}
        />
        <KeyboardDatePicker
          data-testid="dob"
          inputProps={{ "data-testid": "dob-input" }}
          autoOk
          variant="inline"
          inputVariant="outlined"
          label="Date of birth"
          value={props?.queryState?.dob || null}
          onChange={(date, str) => handleDateChange(date, str)}
          format="YYYYMMDD"
          helperText="Date format: YYYYMMDD"
          disableFuture={true}
          style={{ width: "45%" }}
          KeyboardButtonProps={{
            "data-testid": "dob-calendar-button",
          }}
        />
        <GenderAutocomplete
          value={props?.queryState?.gender}
          handleChange={handleChange}
        />
      </div>
      <div style={{ display: "flex", alignItems: "center", columnGap: "5px" }}>
        <p style={{ fontWeight: "bold", margin: 0 }}>Conditional Fields</p>
        <TooltipIcon
          hoverText="These fields may be required or not allowed"
          text="These fields may be required or not allowed based on the state selected in the Destination field above. Refer to the state-specific guidelines from NLETs for more information."
        />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          border: "1px solid black",
          justifyContent: "space-between",
          padding: _spacing,
        }}
      >
        <TextField
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          margin="dense"
          id="oln-id"
          label="Operator's License Number"
          helperText="Provincial PID/OLN no dash"
          value={props?.queryState?.oln || ""}
          onChange={handleChange}
          name="oln"
          style={{ width: "45%" }}
        />
        <SingleDropDown
          title={"Reason Code"}
          value={props?.queryState?.reasonCode}
          stateName={"reasonCode"}
          options={props.reasonCodes}
          handleChange={handleChange}
          inputLabel={inputLabel}
          labelWidth={labelWidth}
          disabled={false}
          name={"fullName"}
        />
        <SingleDropDown
          title={"Property In Sight"}
          value={props?.queryState?.propInSight}
          stateName={"propInSight"}
          options={props.propInSights}
          handleChange={handleChange}
          inputLabel={inputLabel}
          labelWidth={labelWidth}
          disabled={false}
          name={"fullName"}
        />
      </div>
    </div>
  );
};

export default UqForm;
